class HavnbyVisualMenu extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.tabs = Array.from(this.querySelectorAll('[data-havnby-visual-tab]'));
    this.panels = Array.from(this.querySelectorAll('[data-havnby-visual-panel]'));

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.activate(index, true));
      tab.addEventListener('focus', () => this.activate(index, false));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));

      if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
        tab.addEventListener('mouseenter', () => this.activate(index, false));
      }
    });
  }

  activate(index, moveFocus) {
    if (!this.tabs[index] || !this.panels[index]) return;

    this.tabs.forEach((tab, tabIndex) => {
      const isActive = tabIndex === index;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', String(isActive));
      tab.tabIndex = isActive ? 0 : -1;
    });

    this.panels.forEach((panel, panelIndex) => {
      panel.hidden = panelIndex !== index;
    });

    if (moveFocus) this.tabs[index].focus({ preventScroll: true });
  }

  handleKeydown(event, index) {
    let nextIndex = null;

    if (event.key === 'ArrowDown' || event.key === 'ArrowRight') {
      nextIndex = (index + 1) % this.tabs.length;
    } else if (event.key === 'ArrowUp' || event.key === 'ArrowLeft') {
      nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = this.tabs.length - 1;
    }

    if (nextIndex === null) return;

    event.preventDefault();
    this.activate(nextIndex, true);
  }
}

if (!window.customElements.get('havnby-visual-menu')) {
  window.customElements.define('havnby-visual-menu', HavnbyVisualMenu);
}
